// extracted by mini-css-extract-plugin
export default {"buyButton":"qGqB6","sizeBig":"AP8Im","hasInCart":"JrkcG","iconCheck":"IITle"};